<template>
  <div class="preview">
    <div class="video" v-if="type === 'video'">
      <video :src="path" controls></video>
    </div>
    <div class="audio" v-if="type === 'audio'">
      <audio :src="path" controls></audio>
    </div>
    <div class="file" v-if="type === 'document'">
      <iframe class="file-iframe" :src="previewPath" frameborder="0"></iframe>
    </div>
    <div class="image" v-if="type === 'image'">
      <el-image class="img" fit="cover" :src="path"></el-image>
    </div>
    <div class="link" v-if="type === 'link'">
      <el-link type="primary" :href="path" target="_blank">{{ path }}</el-link>
    </div>
    <div class="rich-text card-shadow" v-if="type === 'richtext'">
      <div v-html="filePath"></div>
    </div>
    <div class="other" v-if="type === 'other'">
      <el-link type="primary" :href="path + '?attname=附件'" target="_blank">{{ path }}</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "preview",
  props: {
    path: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    fileType: {
      type: String
    }
  },
  data() {
    return {
      previewPath: ""
    };
  },
  created() {
    if (!this.type) {
      const ext = this.path.substr(this.path.lastIndexOf(".") + 1);
      this.type = this.getFileType(ext);
    }

    if (this.type === "document") {
      const ext = this.path.substr(this.path.lastIndexOf(".") + 1);

      switch (ext) {
        case "doc":
        case "docx":
          this.previewPath =
            "https://vip.ow365.cn/?ssl=1&i=16664&n=1&p=1&furl=" +
            encodeURIComponent(this.path);
          break;
        case "ppt":
        case "pptx":
          this.previewPath =
            "https://vip.ow365.cn/?ssl=1&i=16664&n=5&p=1&furl=" +
            encodeURIComponent(this.path);
          break;
        case "xls":
        case "xlsx":
          this.previewPath =
            "https://vip.ow365.cn/?ssl=1&i=16664&p=1&furl=" +
            encodeURIComponent(this.path);
          break;
        case "pdf":
          this.previewPath =
            "https://vip.ow365.cn/?ssl=1&i=16664&p=1&furl=" +
            encodeURIComponent(this.path);
          break;
        default:
          this.previewPath =
            "https://vip.ow365.cn/?ssl=1&i=16664&p=1&furl=" +
            encodeURIComponent(this.path);
      }
    }
    // https://vip.ow365.cn/?i=16664&n=1&furl=http%3A%2F%2Fofficeweb365.com%2Fviewfile%2F%E5%85%B3%E4%BA%8E%E5%8A%A0%E5%BF%AB%E4%B8%B4%E6%97%B6%E8%AE%BE%E6%96%BD%E5%BB%BA%E8%AE%BE%E9%80%9F%E5%BA%A6%E5%92%8C%E4%BF%9D%E8%AF%81%E5%BB%BA%E8%AE%BE%E6%A0%87%E5%87%86%E7%9A%84%E9%80%9A%E7%9F%A5.docx&p=1
    // https://vip.ow365.cn/?i=16664&furl=http%3A%2F%2Fofficeweb365.com%2Fviewfile%2F%E5%9C%A8%E7%BA%BF%E9%A2%84%E8%A7%88Office%E6%9C%8D%E5%8A%A1%E8%B4%B9%E7%94%A8%E8%AF%B4%E6%98%8E%EF%BC%88%E9%A2%84%E8%A7%88%E7%A4%BA%E4%BE%8B%E6%96%87%E4%BB%B6%EF%BC%89.xlsx&p=1
    // https://vip.ow365.cn/?i=16664&n=5&furl=http%3A%2F%2Fofficeweb365.com%2Fviewfile%2F%E6%B7%B1%E5%85%A5%E6%B5%85%E5%87%BAHTML5%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.pptx&p=1
    // https://vip.ow365.cn/?i=16664&furl=http%3A%2F%2Fofficeweb365.com%2Fviewfile%2F%E4%B8%9A%E7%BB%A9%E5%85%AC%E5%B8%832013%E5%B9%B4%E7%AC%AC%E5%9B%9B%E5%AD%A3%E5%BA%A6%E5%8F%8A%E5%85%A8%E5%B9%B4%E4%B8%9A%E7%BB%A9.pdf&p=1
    // https://vip.ow365.cn/?i=16664&furl=http%3A%2F%2Fofficeweb365.com%2Fviewfile%2FOfficeWeb365%E5%9C%A8%E7%BA%BF%E9%A2%84%E8%A7%88Word%E6%96%87%E6%A1%A3%E5%8F%8A%E5%85%B6%E5%AE%83%E6%96%87%E6%A1%A3.txt&p=1
  },
  methods: {
    getFileType(ext) {
      let mime_types = [
        {
          title: "document",
          extensions: "doc,docx,xls,xlsx,ppt,pptx,pdf,txt"
        },
        {
          title: "image",
          extensions: "png,jpg,gif,jpeg,bmp"
        },
        {
          title: "video",
          extensions: "flv,mp4,avi,wmv,rm,rmvb,mpeg,mov,mpg"
        },
        {
          title: "audio",
          extensions: "mp3,wav,wma"
        },
        {
          title: "rar",
          extensions: "rar,zip"
        }
      ];
      if (ext == "" || ext == null) {
        return "richtext";
      } else {
        ext = ext.toLowerCase();
      }
      for (let i = 0; i < mime_types.length; i++) {
        let extArr = mime_types[i].extensions.split(",");
        for (let j = 0; j < extArr.length; j++) {
          if (extArr[j] == ext) {
            return mime_types[i].title;
          }
        }
      }
      return "other";
    }
  }
};
</script>

<style scoped>
.preview {
  text-align: center;
}

video {
  width: 840px;
}

video,
audio {
  max-width: 100%;
}

.file-iframe {
  width: 100%;
  /* 对不支持vh浏览器降级处理 */
  height: 600px;
  height: 60vh;
  background-color: #fff;
  border: 1px solid #eee;
}

.rich-text {
  padding: 30px;
  background-color: #fff;
  border: 1px solid #eee;
  text-align: initial;
}

@media (max-width: 767px) {
  .rich-text {
    padding: 15px;
  }
}
</style>
